import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

//pages and components

import Accountinfo from './pages/Accountinfo'
import Test from './pages/Test'
import Viewtuckshop from './pages/Viewtuckshop'
import Earnmoney from './pages/Earnmoney'
import Matuckshop from './pages/Matuckshop'
import Home from './pages/Home'
import Navbar from './components/Navbar'
import Login from './pages/Login'
import Signup from './pages/Signup'
import { useAuthContext } from './hooks/useAuthContext'

function App() {
  
  const {user} = useAuthContext()

  return (
    <div className="App">
      <BrowserRouter>
      <Navbar/>
      <div className="pages">
        <Routes>
        <Route
          path="/test"
          element={ <Test /> }
          />
        <Route
          path="/matuckshop"
          element={ <Matuckshop /> }
          />
           <Route
          path="/viewtuckshop"
          element={ <Viewtuckshop /> }
          />
           <Route
          path="/earnmoney"
          element={ <Earnmoney/> }
          />
          <Route
          path="/"
          element={user ? <Home/> : <Navigate to ="/login"/>}
          />
          <Route
          path="/accountinfo"
          element={user?<Accountinfo/>:<Navigate to ="/login"/>}
          />
            <Route
          path="/login"
          element={!user ? <Login/>: <Navigate to="/" />}
          />
          <Route
          path="/signup/*"
          element={!user ? <Signup/> : <Navigate to="/" />}
          />
        </Routes>
      </div>
      
      </BrowserRouter>
    </div>
  );
}

export default App;
